import type {
  ClientContractFormatted,
  ClientContractIncludedType,
  ClientContractType,
} from '../../../types'

type ClientContractBuildInput = {
  clientContractData: ClientContractType
  clientContractIncluded: ClientContractIncludedType
}

export default class ClientContractBuild {
  private clientContractFormatted: ClientContractFormatted

  constructor(private clientContractBuildInput: ClientContractBuildInput) {
    const included = this.clientContractBuildInput.clientContractIncluded

    const extraOptionsAmount =
      (this.clientContractBuildInput.clientContractData
        .conciergeriePackagePrice ?? 0) +
      (this.clientContractBuildInput.clientContractData.koalaInsurancePrice ??
        0)

    // Inject the option(s) amount to the first contract payment
    const contractPayments = (
      Array.isArray(included.contractPayments)
        ? included.contractPayments.sort((a, b) => a.position - b.position)
        : [included.contractPayments]
    )
      .filter(Boolean)
      .map((payment, i) => {
        if (i !== 0 || !extraOptionsAmount) return payment
        // Add the option(s) amount to the first payment
        const firstAmount = Number(payment.amount)
        const safeFirstAmount = isNaN(firstAmount) ? 0 : firstAmount
        const amount = (safeFirstAmount + extraOptionsAmount).toFixed(2)
        return { ...payment, amount }
      })

    // Inject the option(s) amount to the first payment transaction
    const paymentTransactions = (
      Array.isArray(included.paymentTransactions)
        ? included.paymentTransactions.sort(
            (a, b) => new Date(a.dueOn).getTime() - new Date(b.dueOn).getTime(),
          )
        : [included.paymentTransactions]
    )
      .filter(Boolean)
      .map((payment, i) => {
        if (i !== 0 || !extraOptionsAmount) return payment
        // Add the option(s) amount to the first payment
        const firstAmount = Number(payment.amount)
        const safeFirstAmount = isNaN(firstAmount) ? 0 : firstAmount
        const amount = (safeFirstAmount + extraOptionsAmount).toFixed(2)
        return { ...payment, amount }
      })

    // Add the option(s) amount to client/total price
    this.clientContractBuildInput.clientContractData.clientPrice =
      (isNaN(this.clientContractBuildInput.clientContractData.clientPrice)
        ? 0
        : this.clientContractBuildInput.clientContractData.clientPrice) +
      extraOptionsAmount

    this.clientContractFormatted = {
      ...this.clientContractBuildInput.clientContractData,
      type: 'clientContract',
      houses: included.houses,
      destinations: included.destinations,
      reviewers: included.reviewers,
      contractPayments,
      paymentTransactions,
      conciergerieOffer: this.getConciergerieOfferType(
        this.clientContractBuildInput.clientContractData.conciergerieOffer,
      ),
    }
  }

  build() {
    return this.clientContractFormatted
  }

  getConciergerieOfferType(conciergerieOffer: string) {
    switch (conciergerieOffer) {
      case 'Essentielle':
      case 'Essential':
        return 'essential'
      case 'Tailor':
        return 'tailor'
      case 'Club':
        return 'club'
      default:
        return 'essential'
    }
  }
}
